import React, { useEffect, useState } from "react";
import { TextInput, SelectInput, DateInput } from "../../Components/Inputs";
import init_devices from "../init_devices";
import Btn from "../../../../Components/Buttons/Btn";
import { useNavigate } from "react-router-dom";
import useAxios from "../../../../Hooks/useAxios";
import useForm from "../../Components/hooks/useForm";

const Add = () => {
  const [input, setInput] = useState(init_devices);
  const navigate = useNavigate();
  const request = useAxios();

  const handleSubmit = async (data) => {
    let res = await request({
      method: "POST",
      url: "warehouses/add",
      body: data,
    });
    if (res === "error") return;
    navigate("/dashboard/warehouses");
  };

  const { handleValidation, validate } = useForm({
    input,
    submit: handleSubmit,
  });

  return (
    <div className="shadow-2xl w-[85%] m-auto border-t p-4 mt-12">
      <h3 className="text-center text-xl font-semibold">Add Warehouse</h3>
      <div className="mt-4">
        <div className="flex gap-5 items-center max-md:flex-col">
          <TextInput
            input={input}
            setInput={setInput}
            field="name"
            validate={validate}
          />
        </div>

        <div className="flex gap-5 items-center max-md:flex-col">
        
          <TextInput
            input={input}
            setInput={setInput}
            field="location"
            validate={validate}
          />
            <TextInput
            input={input}
            setInput={setInput}
            field="description"
            validate={validate}
          />
        </div>

    
      </div>

      <div className="mt-4 flex justify-between">
        <Btn onClick={() => navigate("/dashboard/devices")}>Back</Btn>
        <Btn onClick={handleValidation}>Submit</Btn>
      </div>
    </div>
  );
};

export default Add;
